import { Box } from "@mui/material";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSystemStateStore } from "../../store/useSystemStateStore";
import { EdgeSystemStatus } from "../../types";
import { getEndpointConfiguration } from "../../utils";
import { Loader } from "../../components/Loader/Loader";
import { LoginForm } from "./LoginForm";
import { SyncError } from "./SyncError";
import { SyncingBlock } from "./SyncingBlock";
import { LOGIN_PAGE_NS } from "./i18n";

export const LoginPage = () => {
  const { t } = useTranslation(LOGIN_PAGE_NS);
  const { isCloud } = getEndpointConfiguration();
  const { initialSyncStatus } = useSystemStateStore();
  const isPerformingInitialSync = !isCloud && [EdgeSystemStatus.Initial, EdgeSystemStatus.Ongoing].includes(initialSyncStatus);

  useEffect(() => {
    document.title = isPerformingInitialSync ? t("documentTitle.sync") : t("documentTitle.login");
  }, [isPerformingInitialSync, t]);

  const form = useMemo(() => {
    if (isCloud) {
      return <LoginForm />;
    }
    
    return {
      [EdgeSystemStatus.Initial]: <Loader simple />,
      [EdgeSystemStatus.Ongoing]: <SyncingBlock /> ,
      [EdgeSystemStatus.Error]: <SyncError />,
      [EdgeSystemStatus.Success]: <LoginForm />,
    }[initialSyncStatus];
  }, [isCloud, initialSyncStatus]);

  return (
    <Box sx={{ display: "flex", justifyContent: "center", m: "0 auto" }}>
      {form}
    </Box>
  );
};
